import React, { useState, useEffect } from "react";
import { Button, TextField, Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";
import API from "../../actions";

export default props => {
    const [open, setOpen] = useState(false);
    const [customFieldId, setCustomFieldId] = useState("");
    const [customFieldName, setCustomFieldName] = useState("");
    const [clientId, setClientId] = useState("");

    const handleClose = async () => {
        setOpen(false);
        setCustomFieldId("");
        setCustomFieldName("");
    };

    const handleSave = async () => {
        handleClose();
        if (!props.new) {
            await API.setCustomField({ id: customFieldId, name: customFieldName });
            props.update(await API.getCustomFieldsFromClientIsNotJournal(clientId));
            return;
        }
        await API.addCustomField({ name: customFieldName, locked: false, isJournal: false });
        props.update(await API.getCustomFieldsFromClientIsNotJournal(props.clientId));
    };

    const handleDelete = async () => {
        handleClose();
        await API.deleteCustomField(customFieldId);
        props.update(await API.getCustomFieldsFromClientIsNotJournal(clientId));
    };

    useEffect(() => {
        (async () => {
            if (props.felter && props.clientId) {
                setCustomFieldId(props.felter.customFieldId);
                setCustomFieldName(props.felter.name);
                setClientId(props.clientId);
            }
        })();
    }, [props.felter, props.clientId]);

    return (
        <div>
            {props.new ? (
                <Button onClick={() => setOpen(true)} disabled={!props.pro} size="small">
                    Tilføj Felt
                </Button>
            ) : (
                <Button onClick={() => setOpen(true)} variant="contained">
                    Rediger
                </Button>
            )}
            <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title" maxWidth="lg">
                {props.new ? (
                    <DialogTitle id="form-dialog-title">Nyt Felt</DialogTitle>
                ) : (
                    <DialogTitle id="form-dialog-title">Rediger Felt</DialogTitle>
                )}

                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="topic"
                        label="Titel"
                        type="text"
                        fullWidth
                        value={customFieldName}
                        onChange={event => setCustomFieldName(event.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Luk
                    </Button>
                    {props.new ? (
                        <Button onClick={handleSave} color="primary">
                            Opret
                        </Button>
                    ) : (
                        <Button onClick={handleSave} color="primary">
                            Gem
                        </Button>
                    )}
                    <Button onClick={handleDelete} color="secondary">
                        Slet
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};
